import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { prependRoot } from "../../util/prependRoot.js";


const RelativeLink = (props) => {
	const {
		siteRoot,
		to,
		title,
		className,
		newTab,
		children,
		style
	} = props;

	const target = newTab ? "_blank" : "";
	const relativeTo = prependRoot(to, siteRoot).toLowerCase();

	return (
		<NavLink
			exact to={relativeTo} target={target} title={title} activeClassName="active"
			className={className} style={style}>{children}
		</NavLink>
	);
};

RelativeLink.propTypes = {
	children: PropTypes.node,
	siteRoot: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	title: PropTypes.string,
	className: PropTypes.string,
	newTab: PropTypes.bool,
	style: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		siteRoot: state.settings.siteRoot
	};
}

export default connect(mapStateToProps)(RelativeLink);
